/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { faCircle, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { truncate } from "../helpers";
import timezones from "../Builder/nodes/Logic/timezones";
import { setCurrentModal } from "../store/slices/modalsSlice";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import MessageIcon from "../../assets/icons/messages-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import { useGetContactFieldsQuery } from "../store/slices/contactsSlice";

const getFieldValue = (field, value) => {
  const { countries } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;

  if (field.isSelect) {
    if (field.selectType === "country") {
      return countries.find((c) => c.country_code === value.data).country_name;
    }
    if (field.selectType === "time-zone") {
      return timezones.find((tz) => tz.tzCode === value.data).label;
    }
    return (
      field.options?.find((o) => o.uuid === value.data)?.label ?? value.data
    );
  }
  return value.data;
};

export default function ContactCard({
  contact,
  contactButton,
  contactFields: cf,
  fullView,
  isModal,
  onSelect,
  showContactFields,
  isSelected,
  highlighChannelsIfNotAvailable,
}) {
  const dispatch = useDispatch();
  const setContactSetModalData = (d) => {
    dispatch(setCurrentModal({ modal: "contactSet", data: d }));
  };

  const { data: contactFields = cf } = useGetContactFieldsQuery(null, {
    skip: cf,
  });
  const contactDetails = Array.isArray(contact?.details) ? contact.details : [];

  return (
    contactFields && (
      <tr>
        {onSelect && typeof onSelect === "function" && (
          <td className="text-nowrap p-2">
            <Form.Check
              onChange={(e) => onSelect(e.target.checked)}
              checked={isSelected}
            />
          </td>
        )}

        {contactButton && <td className="p-2">{contactButton(contact)}</td>}

        {fullView && (
          <td className="p-2">
            <span
              className="text-capitalize text-nowrap"
              style={{ maxWidth: 100 }}
            >
              <FontAwesomeIcon
                icon={faCircle}
                className={`${
                  contact.status === "active" ? "text-success" : ""
                }${contact.status === "incomplete" ? "text-warning" : ""} me-2`}
              />

              {contact.status}
            </span>
          </td>
        )}

        {contactFields
          .filter((cfi) => cfi.isCard || showContactFields?.includes(cfi.uuid))
          .sort((a, b) => a.order - b.order)
          .map((field) => {
            const values =
              contactDetails.find((d) => d.field.uuid === field.uuid)
                ?.values ?? [];
            return (
              <td key={`${contact.uuid}-${field.uuid}`} className="p-2">
                {values.map((value, index) => (
                  <span
                    key={`${contact.uuid}-${field.uuid}-${index}`}
                    className="text-nowrap"
                  >
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      rootClose
                      overlay={
                        <Popover
                          id={`${contact.uuid}-${field.uuid}-value-popover`}
                          className="p-2"
                          style={{ zIndex: 15000 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div>{getFieldValue(field, value)}</div>
                        </Popover>
                      }
                    >
                      <span className="btn p-0 d-inline-block">
                        {truncate(getFieldValue(field, value))}
                      </span>
                    </OverlayTrigger>

                    {index < values.length - 1 ? (
                      <span className="mx-2">/</span>
                    ) : (
                      ""
                    )}
                  </span>
                ))}
              </td>
            );
          })}

        <td className="p-2 text-nowrap">
          {
            // channel icons
            [
              { label: "isEmail", icon: EmailIcon, title: "Email" },
              { label: "isSms", icon: MessageIcon, title: "SMS" },
              { label: "isVoice", icon: VoiceIcon, title: "Voice" },
              // { label: "isWhatsApp", icon: WhatsAppIcon, title: "WhatsApp" },
              // { label: "isMessanger", icon: MessangerIcon, title: "Messenger" },
              // { label: "isRcs", icon: RcsIcon, title: "RCS" },
            ].map((channel) => {
              const channelAvailable = contactDetails.some(
                (d) => d.field[channel.label]
              );
              return (
                <OverlayTrigger
                  key={channel.label}
                  trigger={"click"}
                  placement="top"
                  rootClose
                  overlay={
                    <Popover
                      id={`${contact.uuid}-${channel.label}-popover`}
                      className="p-2"
                      style={{ zIndex: 15000 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {channelAvailable
                        ? contactDetails
                            .filter((d) => d.field[channel.label])
                            .map((d, index) => (
                              <div className="text-nowrap" key={index}>
                                <span className="text-secondary me-2">
                                  {d.field.label}:
                                </span>
                                {d.values[0].data}
                              </div>
                            ))
                        : `This contact does not have a communication address for ${channel.title} channel!`}
                    </Popover>
                  }
                >
                  <button
                    aria-label={channel.title}
                    type="button"
                    className={`btn px-1 bg-icon rounded-2 py-0 me-1 border-1 position-relative ${
                      highlighChannelsIfNotAvailable?.includes(channel.label) &&
                      !channelAvailable
                        ? "border-danger"
                        : "border-opacity-10"
                    }`}
                    // disabled={!channelAvailable}
                  >
                    {highlighChannelsIfNotAvailable?.includes(channel.label) &&
                      !channelAvailable && (
                        <FontAwesomeIcon
                          icon={faXmarkCircle}
                          className="position-absolute top-0 start-100 translate-middle bg-white rounded-circle text-danger "
                        />
                      )}
                    <channel.icon
                      width={15}
                      className={`  ${channelAvailable ? "" : "opacity-25"} `}
                    />
                  </button>
                </OverlayTrigger>
              );
            })
          }
        </td>

        {fullView && (
          <>
            <td className="text-nowrap p-2">
              {contact.contactSets && (
                <OverlayTrigger
                  trigger="click"
                  placement="top"
                  rootClose
                  overlay={
                    <Popover
                      id={`${contact.uuid}-groups-popover`}
                      className="p-2"
                      style={{ zIndex: 15000 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {contact.contactSets.map((cs) => (
                        <div className="text-nowrap" key={cs.uuid}>
                          {isModal ? (
                            <button
                              type="button"
                              onClick={() =>
                                setContactSetModalData({
                                  uuid: cs.uuid,
                                  onClose: () => null,
                                })
                              }
                              className="btn btn-link px-0"
                            >
                              {cs.label}
                            </button>
                          ) : (
                            <Link to={`/assets/contacts/groups/${cs.uuid}`}>
                              {cs.label}
                            </Link>
                          )}
                          - {cs.type} - {cs.membersCount} members
                        </div>
                      ))}
                    </Popover>
                  }
                >
                  <span
                    className="btn p-0 d-inline-block text-truncate"
                    style={{ maxWidth: 120 }}
                  >
                    {contact.contactSets?.length}
                  </span>
                </OverlayTrigger>
              )}
            </td>

            <td className="text-nowrap p-2">
              {contact.createdAt &&
                new Date(
                  `${contact.createdAt.split(" ")[0]}T${
                    contact.createdAt.split(" ")[1]
                  }${contact.createdAt.split(" ")[2]}`
                ).toLocaleString()}
            </td>
          </>
        )}
      </tr>
    )
  );
}
